import { ajax } from "jquery";
import audience from "./audience";
import { SectionSwitcher } from "../jobs-flow/SectionSwitcher";
import { SaveButton } from "../components/SaveButton";
import HelpTicket from "../CRUDs/entities/HelpTicket";
import { AutoTicket } from "../components/AutoTicket";
import { HasAttachments } from "../CRUDs/abstracts/mixins/HasAttachments";

export default{
    init(){
        this.updateMailSpecification();
        this.changeEmailType();
        this.selectEmail();
        this.updateMailText();
        this.saveEmailDesigningTemplate();
        this.uploadCompanyLogo();
        this.uploadCenterImage();
        this.saveCampaignEmail();
        this.saveCampaignAudience();
        this.saveNewCampaign();
        this.showModal();
        this.filterEmailCampaigns();
        this.deleteEmailCampaignInformation();
        this.initColorPicker();
        this.resetMailsDesign();
        this.scheduleCampaign();
        this.sendTestEmail();
        this.updateSystemEmail();
        this.checkingBusinessEmail();
        this.showEmailInFrame();
        this.initPagination();
        this.initMasks();
        this.initDescriptionModals();
        let currPath = window.location.pathname;
        if (currPath.includes('/email-department')) {
            HasAttachments.id = 1;
            HasAttachments.urlRoot='/email-department';
            HasAttachments.scopeOpenDropZoneListener({
                email_id: $('#email_id').val(),
            }, this.uploadCallback);
        }

        var SectionSwitcher;
        this.SaveBtn = new SaveButton();
    },

    initColorPicker(){
        if(window.location.pathname == '/email-department/email-designing-template'){
            $('#header-bg-color-input').colorpicker();
            $('#footer-bg-color-input').colorpicker();
            $('#header-company-name-color').colorpicker();
            $('#footer-color-input').colorpicker();
            $('#body-text-color').colorpicker();
            $('#button-color').colorpicker();
        }
    },

    initMasks(){
        $('#last_order_value').mask('999999999');
        $('#total_spent_value').mask('$99999999');
    },

    updateMailSpecification(){
        $('#company-tag-input').change(function(e) {
            e.preventDefault();
            var tag = this.value;
            $('.company-tag').text(tag);
            $("#email_frame").contents().find(".company-tag").text(tag);
            if (tag.length>0) {
                $('.company-tag').css('display', '');
            } else {
                $('.company-tag').css('display', 'none');
            }

        });
        $('#header-bg-color-input').change(function(e) {
            e.preventDefault();
            if (this.value == '') {
                $('#header-bg-color-input').css('border-color', 'red');
                $('#save_emailing_template').attr('disabled', true);
            } else {
                $('#header-bg-color-input').css('border-color', '');
                $('#save_emailing_template').removeAttr('disabled');
                $('#mail-header').css('background', this.value);

                $("#email_frame").contents().find("#mail-header").css('background', this.value);
            }
        });
        $('#footer-bg-color-input').change(function(e) {
            e.preventDefault();
            if (this.value == '') {
                $('#footer-bg-color-input').css('border-color', 'red');
                $('#save_emailing_template').attr('disabled', true);
            } else {
                $('#footer-bg-color-input').css('border-color', '');
                $('#save_emailing_template').removeAttr('disabled');
                $('#mail-footer').css('background', this.value);

                $("#email_frame").contents().find("#mail-footer").css('background', this.value);
            }
        });
        $('#header-company-name-color').change(function(e) {
            e.preventDefault();
            if (this.value == '') {
                $('#header-company-name-color').css('border-color', 'red');
                $('#save_emailing_template').attr('disabled', true);
            } else {
                $('#header-company-name-color').css('border-color', '');
                $('#save_emailing_template').removeAttr('disabled');
                $('#mail-header').css('color', this.value);

                $("#email_frame").contents().find("#mail-header").css('color', this.value);
            }
        });
        $('#footer-color-input').change(function(e) {
            e.preventDefault();
            if (this.value == '') {
                $('#footer-color-input').css('border-color', 'red');
                $('#save_emailing_template').attr('disabled', true);
            } else {
                $('#footer-color-input').css('border-color', '');
                $('#save_emailing_template').removeAttr('disabled');
                $('#mail-footer').css('color', this.value);

                $("#email_frame").contents().find("#mail-footer td").css('color', this.value);
            }
        });
        $('#body-text-color').change(function(e) {
            e.preventDefault();
            if (this.value == '') {
                $('#body-text-color').css('border-color', 'red');
                $('#save_emailing_template').attr('disabled', true);
            } else {
                $('#body-text-color').css('border-color', '');
                $('#save_emailing_template').removeAttr('disabled');
                $('#mail-body').css('color', this.value);

                $("#email_frame").contents().find("#mail-body td, th").css('color', this.value);
            }
        });
        $('#body-headline-size').change(function(e) {
            e.preventDefault();
            $('#headline').css('font-size', this.value);

            $("#email_frame").contents().find("#headline").css('font-size', this.value);
        });
        $('#mail-font-style').change(function(e) {
            e.preventDefault();
            $('#main-mail').css('font-family', this.value);
            $("#email_frame").contents().find("#main-mail").css('font-family', this.value);
        });
        $('#input-file').change(function(e) {
            e.preventDefault();
            if(this.value !=''){
                $('#input-file-label').text('Selected '+this.files.length+' file');
            }else{
                $('#input-file-label').text('click to select logo from device');
            }
        });
        $('#button-color').change(function(e) {
            e.preventDefault();
            if (this.value == '') {
                $('#button-color').css('border-color', 'red');
                $('#save_emailing_template').attr('disabled', true);
            }else{
                $('#save_emailing_template').removeAttr('disabled');
                $('#button-color').css('border-color', '');
                $("#email_frame").contents().find('button, a[type=button]').css('background', this.value);
            }
        });
    },

    changeEmailType(){
        $('#email_type_select').change(function(e) {
            e.preventDefault();
            if(this.value=='promo'){
                $('#promo_info').css('display', '');
                $('#updates_info').css('display', 'none','!important');
                $('#conditional_info').css('display', 'none','!important');
                $('#email_recipient').val('matching');
                $('#email_recipient').attr('disabled', false);
                $('#email_recipient').addClass('text-black');
                $('#email_recipient').removeClass('text-muted');
            }else if(this.value=='updates'){
                $('#promo_info').css('display', 'none','!important');
                $('#updates_info').css('display', '');
                $('#conditional_info').css('display', 'none','!important');

                $('#email_recipient').val('all_customers');
                $('#email_recipient').attr('disabled', true);
                $('#email_recipient').addClass('text-muted');
                $('#email_recipient').removeClass('text-black');
                audience.findAllCustomers();
            }else if(this.value=='conditional'){
                $('#promo_info').css('display', 'none','!important');
                $('#updates_info').css('display', 'none','!important');
                $('#conditional_info').css('display', '');

                $('#email_recipient').val('matching');
                $('#email_recipient').attr('disabled', true);
                $('#email_recipient').addClass('text-muted');
                $('#email_recipient').removeClass('text-black');
            }
        });
        $('#email_recipient').change(function () {
            if (this.value == 'all_customers' || this.value == 'all_waitlist')  {
                $('#promo_info').css('display', 'none','!important');
                $('#updates_info').css('display', '');
                $('#conditional_info').css('display', 'none','!important');

                if (this.value == 'all_customers') {
                    $('#customers_updates_info').css('display', '');
                    $('#waitlist_updates_info').css('display', 'none');
                } else if (this.value == 'all_waitlist') {
                    $('#waitlist_updates_info').css('display', '');
                    $('#customers_updates_info').css('display', 'none');
                }
            }else{
                $('#promo_info').css('display', '');
                $('#updates_info').css('display', 'none','!important');
                $('#conditional_info').css('display', 'none','!important');
            }
        });
    },

    selectEmail(){
        $('#email_select').change(function() {
            if(this.value == 'welcome'){
                $('#email-description-text').text('Email will be sent to customers who placed their first service order.');
                $('#lost_customer_additional').hide();
            }else if(this.value == 'personal_cabinet'){
                $('#email-description-text').text('Email will be sent to customers who placed their first service order. You can’t edit content of this email.');
                $('#lost_customer_additional').hide();
            }else if(this.value == 'feedback'){
                $('#email-description-text').text('Email will be sent to customers 3 days after their first job was completed.');
                $('#lost_customer_additional').hide();
            }else if(this.value == 'lost_customer'){
                $('#email-description-text').text('Email will be automatically sent to customers who have’t placed a service order for 30 days.');
                $('#lost_customer_additional').css('display', 'flex');
            }
        });
        $('#lost_customer_days').change(function() {
            $('#lcd_value').text(this.value);
            conditions = {
                lost_customer_days: this.value,
            };
        });
        $('#feedback_days').change(function() {
            $('#fbd_value').text(this.value);
            conditions = {
                feedback_days: this.value,
            };
        })
    },

    updateMailText(){
        $('#email_subject').change(function() {

        });
        $('#email_headline').change(function() {
            $('#headline').text(this.value);
            $("#email_frame").contents().find('#headline').text(this.value);
        });
        $('#email_customer_name').change(function() {
            $('#customer-name').text(this.value);
            $("#email_frame").contents().find('#customer-name').text(this.value);
        });
        $('#email_top_content').change(function() {
            console.log(this.value, $('#top-content'));
            $('#top-content').text(this.value);
            $("#email_frame").contents().find('#top-content').text(this.value);
        });
        $('#email_bottom_content').change(function() {
            var arr = this.value.split('\n');
            var arr2 = arr.filter((element)=> element.length>0);
            $('#bottom-content').html('');
            $("#email_frame").contents().find('#bottom-content').html('');
            arr2.forEach((element, index, array) => {
                if (element != '') {
                    if (index == array.length - 1) {
                        $('#bottom-content').append('<p style="padding-bottom: 20px;margin: 0;">'+element+'</p>');
                        $("#email_frame").contents().find('#bottom-content').append('<p style="padding-bottom: 20px;margin: 0;">'+element+'</p>');
                    }else{
                        $('#bottom-content').append('<p style="margin: 0;">'+element+'</p>');
                        $("#email_frame").contents().find('#bottom-content').append('<p style="margin: 0;">'+element+'</p>');
                    }
                }
            });
        });
        $('#activate_center_image').on('change',function() {
            if($(this).is(':checked')==true){
                $('#body_img_line').css('display','table-row');
                $("#email_frame").contents().find('#body_img').css('display','initial');
                $("#email_frame").contents().find('#body_img').parent().css('display','');
            }else{
                $('#body_img_line').css('display','none');
                $("#email_frame").contents().find('#body_img').css('display','none');
                $("#email_frame").contents().find('#body_img').parent().css('display','none');
            }
        })
    },

    saveEmailDesigningTemplate(){
        let _this = this;
        $('#save_emailing_template').click(function() {
            $.ajax({
                type: 'POST',
                url: '/email-department/save-email-template',
                data: ({
                    bg_color_header: $('#header-bg-color-input').val(),
                    bg_color_footer: $('#footer-bg-color-input').val(),
                    color_company_name: $('#header-company-name-color').val(),
                    color_footer_text: $('#footer-color-input').val(),
                    color_body_text: $('#body-text-color').val(),
                    headline_size: $('#body-headline-size').val(),
                    font_style: $('#mail-font-style').val(),
                    company_tag: $('#company-tag-input').val(),
                    image_link: $('#path_logo').val(),
                    button_color: $('#button-color').val(),
                }),
                beforeSend: function() {
                    _this.SaveBtn.startLoading();
                },
                success: function(response) {
                    _this.SaveBtn.stopLoading();
                    _this.SaveBtn.showSuccess();
                },
                error: function(resp) {
                    $('.error-log').text(resp.responseJSON.message);
                }
            });
        });
    },

    uploadCompanyLogo(){
        $('#upload_company_logo').click(function() {
            let directory = 'email-templates';
            let form = $('#uplaod_img_form')[0];
            let data = new FormData(form);
            data.append('directory', directory);
            $.ajax({
                type: 'POST',
                url: '/email-department/upload-image',
                data: data,
                enctype: 'multipart/form-data',
                processData: false,
                contentType: false,
                success: function(response) {
                    $('#header-logo').attr('src', response);
                    $("#email_frame").contents().find("#header-logo").attr('src', response);
                    $('#header-logo').css('display', '')
                    $('#path_logo').val(response);
                },
                error: function(resp) {
                    $('.error-log').text(resp.responseJSON.message);
                }
            });
        });
    },

    uploadCenterImage(){
        $('#upload_center_img').click(function() {
            if($('#input-file').val()== ''){
                $('#input-file-label').css('border-color', 'red');
            }else{
                $('#input-file-label').css('border-color', '');
                let directory = 'campaign-email-img';
                let form = $('#uplaod_img_form')[0];
                let data = new FormData(form);
                data.append('directory', directory);
                $.ajax({
                    type: 'POST',
                    url: '/email-department/upload-image',
                    data: data,
                    enctype: 'multipart/form-data',
                    processData: false,
                    contentType: false,
                    success: function(response) {
                        $('#body_img').attr('src', response);
                        $("#email_frame").contents().find('#body_img').attr('src', response);
                        $('#path_img').val(response);
                        //location.href = '/email-department';
                    },
                    error: function(resp) {
                        $('.error-log').text(resp.responseJSON.message);
                    }
                });
            }
        });
    },

    saveCampaignEmail(){
        $('#save_campaign_email').click(function() {
            $('.bb-preloader-container').show();
            let data = {
                title: $('#email_title').val(),
                subject: $('#email_subject').val(),
                headline: $('#email_headline').val(),
                customer_greeting: $('#email_customer_name').val(),
                top_content: $('#email_top_content').val(),
                center_image_link:  $('#activate_center_image').is(':checked')==true ? $('#path_img').val() : '',
                bottom_content: $('#email_bottom_content').val(),
                email_id: $('#email_id').val(),
                campaign_id: $('#campaign_id').val(),
                email_type: $('#email_type').val(),
                remind_days: $('#remind_days').val(),
                lost_customer_days: $('#lost_customer_days').val()
            };
            $.ajax({
                type: 'POST',
                url: '/email-department/save-campaign-email',
                data: data,
                success: function(response) {
                    var audience ='';
                    var type ='';
                    if($('#audience_id').val()!=''){
                        audience = '&audience_id='+$('#audience_id').val();
                    }
                    if($('#campaign_id').val()!=0){
                        audience += '&campaign_id='+$('#campaign_id').val();
                    }
                    if($('#email_type').val()=='system'){
                        type += '&email_type='+$('#email_type').val();
                    }
                    $('.bb-preloader-container').hide();
                    if(! parent.window.location.href.match("organization-management")){ //поставить правильный регекс
                        if ($('#email_type').val()=='system') {
                            location.href = '/email-department/';
                        }else{
                            location.href = '/email-department/new-campaign?email_id='+response.cm + audience + type;
                        }
                    }
                },
                error: function(resp) {
                    $('.error-log').text(resp.responseJSON.message);
                }
            });
        });
    },

    saveCampaignAudience(){
        $('body').on('click','.save_audience_btn', function() {
            var conditions = {};
            if($('#email_type_select').val() == 'promo'){
                if($('#email_recipient').val() == 'matching'){
                    conditions = {
                        email_recipient: $('#email_recipient').val(),
                        last_order: $('#last_order_select').val(),
                        last_order_value: $('#last_order_value').val().replace(' days',''),
                        query_connector: $('#operator_select').val(),
                        total_spent: $('#total_spent_select').val(),
                        total_spent_value: $('#total_spent_value').val().replace('$',''),
                    }
                }else{
                    conditions = {
                        email_recipient: $('#email_recipient').val(),
                    }
                }
            }else if($('#email_type_select').val() == 'conditional'){
                if ($('#email_select').val() == 'lost_customer') {
                    conditions = {
                        email_recipient: $('#email_recipient').val(),
                        email_select: $('#email_select').val(),
                        lost_customer_days: $('#lost_customer_days').val(),
                    }
                } else {
                    conditions = {
                        email_recipient: $('#email_recipient').val(),
                        email_select: $('#email_select').val(),
                    }
                }
            }else{
                conditions = {
                    email_recipient: $('#email_recipient').val(),
                }
            }
            let data = {
                title: $('#audience_title').val(),
                email_type: $('#email_type_select').val(),
                conditions: JSON.stringify(conditions),
                audience_id: $('#audience_id').val(),
                campaign_id: $('#campaign_id').val(),
                customer_count: $('#customer_counts').val(),
            }
            $('.bb-preloader-container').show();
            $.ajax({
                type: 'POST',
                url: '/email-department/save-campaign-audience',
                data: data,
                success: function(response) {
                    var email ='';
                    if($('#email_id').val() !=''){
                        var email = '&email_id='+$('#email_id').val();
                    }
                    if($('#campaign_id').val()!=0){
                        email += '&campaign_id='+$('#campaign_id').val();
                    }
                    location.href = '/email-department/new-campaign?audience_id='+response.ea + email;
                },
                error: function(resp) {
                    $('.error-log').text(resp.responseJSON.message);
                    $('.bb-preloader-container').hide();
                }
            });
        });
    },

    saveNewCampaign(){
        var $this= this;
        $('#save_new_campaign').click(function() {
            $('#save_new_campaign').attr('disabled', true);
            if ($('#email_id').val()!='' && $('#audience_id').val()!='') {
                $this.sendCampaign($('#email_id').val(), $('#audience_id').val(), $('#campaign_id').val(), $('#campaign_schedule_date').val());
            }else if($('#email_id').val()!='' && $('#email_type').val()!=''){
                $this.sendCampaign($('#email_id').val(), $('#audience_id').val(), $('#campaign_id').val(), $('#campaign_schedule_date').val(), $('#email_type').val(), $('#lost_customer_days').val(), $('#feedback_days').val());
            }else{
                if ($('#email_id').val() == '') {
                    $('.create-email-link').addClass('text-danger');
                }else{
                    $('.create-email-link').removeClass('text-danger');
                }
                if ($('#audience_id').val() == '') {
                    $('.create-audience-link').addClass('text-danger');
                }else{
                    $('.create-audience-link').removeClass('text-danger');
                }
                $('#save_new_campaign').attr('disabled', false);
            }
        });
        $('#close_without_saving').click(function() {
            $('.bb-preloader-container').show();
            location.href = '/email-department';
        })
    },

    showModal(){
        var $this=this;
        /* $('.show-more-info').click(function() {

            // var data = {
            //     type: $(this).data("type"),
            //     id: $(this).data("id"),
            // };

            //$this.getModal(data);
        }); */
        $('body').on('click','.show_progress_modal', function () {
            $('#more-info-modal').modal('hide');
            var data ={
                id: $(this).data("id"),
                type: $(this).data("type"),
            };
            $this.getModal(data);
        });
        $('body').on('click','.test_email_btn', function(e) {
            e.preventDefault();
            let name = $(this).data('name');
            $('#'+name+'-modal').modal('hide');
            $('#send_test_email_btn').data('email_id', $(this).data('email_id'));
            $('#testing_email_modal').modal('show');
        });
        $('body').on('click','.view_email_btn', function() {
            $('#more-info-modal').modal('hide');
        });
        $('.schedule_campaign_btn').click(function(e) {
            e.preventDefault();
            $('#schedule_campaign_modal').modal('show');
        });
        $('.send_now_campaign').click(function(e) {
            $('#send_now_confirmation_modal').modal('show');
        });

        /* $('.show-system-more-info').click(function() {
            var data = {
                type: $(this).data("type"),
                id: $(this).data("id"),
            };
            $this.getModal(data);
        }); */

        $('body').on('click', '#view_email_modal_btn', function() {
            $('#show_email_modal').modal('show');
            let email_type = '', system_type = '', campaign_id = '';
            if ($(this).data('email_type') == 'system') {
                email_type='?email_type='+$(this).data('email_type');
            }
            if ($(this).data('system_type')) {
                system_type='&system_type='+$(this).data('system_type');
            }
            if ($(this).data('campaign_id')) {
                campaign_id = '&campaign_id='+$(this).data('campaign_id');
            }
            $('#show_email_modal iframe').attr('src', location.origin+'/email-department/show-email/'+$(this).data('email_id')+email_type+system_type + campaign_id);
            $(this).parent().parents('.modal').modal('hide');
        })
        $('#show_email_modal #test_frame').on('load', function () {
            setTimeout(
                function() {
                    $('#show_email_modal iframe').height(window.frames.test_frame.document.body.children[0].offsetHeight);
                }, 200
            );
        })

        $('body').on('click', '.view_emails_list', function() {
            var data = {
                type: $(this).data("type"),
                id: $(this).data("campaign_id"),
            };
            $this.getModal(data);
        })
    },

    /**
     *
     * @param {array} data
     */
    getModal(data){
        $('.bb-preloader-container').show();
        $.ajax({
            type: 'POST',
            url: '/email-department/get-modal',
            data: data,
            success: function(response) {
                $('.modal-backdrop').remove();
                $('#modal_container').html(response);
                $('#'+data.type+'-modal').modal('show');
                $('.bb-preloader-container').hide();
            }
        });
    },

    filterEmailCampaigns(){
        let $this = this;
        $('#filter_email_campaigns').change(function() {
            var filter = this.value;
            var treads = $('#email_campaigns_table').find('tbody').find('tr');
            treads.each(function () {
                if (filter == 'all') {
                    $(this).css('display', '');
                    $(this).addClass('data-row');
                } else {
                    var cells=$(this).find('td');
                    if(cells[4].innerText!= filter){
                        cells[4].parentElement.style.display = 'none';
                        cells[4].parentElement.classList.remove('data-row');
                    }
                    else{
                        cells[4].parentElement.style.display = 'table-row';
                        cells[4].parentElement.classList.add('data-row');
                    }
                }
            });
            $this.sectionSwitcher.init();
            $this.sectionListener();
        });
    },

    deleteEmailCampaignInformation(){
        $('.delete-email-btn').click(function() {
            $.ajax({
                type: 'POST',
                url: '/email-department/delete-campaign-email',
                data: {
                    email_id: $('#email_id').val(),
                    campaign_id: $('#campaign_id').val(),
                },
                success: function(response) {
                    location.reload(true);
                },
                error: function(resp) {
                    $('.error-log').text(resp.responseJSON.message);
                }
            });
        });

        $('.delete-audience-btn').click(function() {
            $.ajax({
                type: 'POST',
                url: '/email-department/delete-campaign-audience',
                data: {
                    audience_id: $('#audience_id').val(),
                    campaign_id: $('#campaign_id').val(),
                },
                success: function(response) {
                    location.reload(true);
                },
                error: function(resp) {
                    $('.error-log').text(resp.responseJSON.message);
                }
            });
        });

        $('body').on('click','.delete_campaign_btn', function() {
            $.ajax({
                type: 'POST',
                url: '/email-department/delete-campaign',
                data: {
                    campaign_id: $(this).data('campaign_id'),
                },
                success: function(response) {
                    location.reload(true);
                },
                error: function(resp) {
                    $('.error-log').text(resp.responseJSON.message);
                }
            });
        });
    },

    resetMailsDesign() {
        $('#reset_emailing_template').click(function(e) {
            $('#reset_emailing_template').attr('disabled', true);
            e.preventDefault();

            if ($('#email-template-id').val() == '') {
                location.reload(true);
            } else {
                let data = {
                    template_id: $('#email-template-id').val(),
                };
                $.ajax({
                    type: 'POST',
                    url: '/email-department/reset-email-template',
                    data: data,
                    success: function(response) {
                        location.reload(true);
                    },
                    error: function(response) {
                        $('.error-log').text(resp.responseJSON.message);
                    }
                });
            }

        });

        $('#reset_campaign_email').click(function(e) {
            e.preventDefault();
            if($('#email_id').val()==''){
                location.reload(true);
            }else{
                $.ajax({
                    type: 'POST',
                    url: '/email-department/reset-campaign-email',
                    data: {
                        email_id: $('#email_id').val(),
                        campaign_id: $('#campaign_id').val(),
                    },
                    success: function(response) {
                        location.reload(true);
                    },
                    error: function(resp) {
                        $('.error-log').text(resp.responseJSON.message);
                    }
                });
            }
        });


    },

    scheduleCampaign() {
        var $this = this;
        $('#schedule_dt_btn').click(function(e) {
            var date_time = '';
            date_time += $('#select-date').val() +' '+ $('#select-time').val();
            $('.schedule_date').text(date_time);
            $('#campaign_schedule_date').val(date_time);
            $('.schedule_date').removeClass('d-none');
            $('#schedule_campaign_modal').modal('hide');
            if ($('#campaign_id').val() == '') {
                $('#save_new_campaign').text('Create Campaign');
            } else {
                $('#save_new_campaign').text('Update Campaign');
            }
        });
        $('.send_now_campaign_btn').click(function(e) {
            e.preventDefault();
            $('.bb-preloader-container').show();
            if ($('#email_id').val() == '') {
                $('.create-email-link').addClass('text-danger');
            }else{
                $('.create-email-link').removeClass('text-danger');
            }
            if ($('#audience_id').val() == '') {
                $('.create-audience-link').addClass('text-danger');
            }else{
                $('.create-audience-link').removeClass('text-danger');
            }
            $('#send_now_confirmation_modal').modal('hide');

            $this.sendCampaign($('#email_id').val(), $('#audience_id').val(), $('#campaign_id').val(), 'now');
            $('.bb-preloader-container').hide();

        });
        $('.remove_scheduled_date').click(function (e) {
            let data = {
                campaign: $(this).data('campaign_id'),
            };
            $.ajax({
                type: 'POST',
                url: '/email-department/remove-scheduled-date',
                data: data,
                success: function(response) {
                    location.reload(true);
                }
            });
        })
    },
    sendCampaign(mail_id, audience_id, campaign_id=null, scheduled_date=null, email_type=null, lost_customer_days=null, feedback_days=null){
        let data = {
            email_id: mail_id,
            audience_id: audience_id,
            id: campaign_id,
            schedule_date: scheduled_date,
            email_type: email_type,
            lost_customer_days:lost_customer_days,
            feedback_days:feedback_days,
        }
        $('.bb-preloader-container').show();
        $.ajax({
            type: 'POST',
            url: '/email-department/save-new-campaign',
            data: data,
            success: function(response) {
                location.href = response.link;
            },
            error: function(resp) {
                $('.error-log').text(resp.responseJSON.message);
                $('.error-log').removeClass('d-none');
                if (resp.responseJSON.error == true) {
                    $('#sender-not-verified-modal').modal('show');
                    const auto_ticket = new AutoTicket('#sender-not-verified-modal', '.create-ticket-button');
                    auto_ticket.createAutoTicket("Something wrong while creating email campaign", JSON.stringify(resp.responseJSON.description));
                }
            }
        });
    },
    sendTestEmail(){
        $('.send_test_email').click((e) => {
            e.preventDefault();
            if ($('#test_email').val() == '' || $('#email_id').val() == '' || !this.checkEmail($('#test_email').val())) {
                $('#test_email').css('border-color', "red");
                return;
            }else{
                $('#test_email').css('border-color', "");
                let data = {
                    email: $('#test_email').val(),
                    email_id: $('#email_id').val(),
                }
                $('.bb-preloader-container').show();
                $.ajax({
                    type: 'POST',
                    url: '/email-department/send-test-email',
                    data: data,
                    success: function(response) {
                        $('.bb-preloader-container').hide();
                    },
                    error: function(resp) {
                        $('.error-log').text(resp.responseJSON.message);
                        $('.bb-preloader-container').hide();
                    }
                })
            }
        });
        $('#send_test_email_btn').click(function(e) {
            e.preventDefault();
            let data = {
                email: $('#test_email').val(),
                email_id: $(this).data('email_id'),
            }

            $('.bb-preloader-container').show();
            $.ajax({
                type: 'POST',
                url: '/email-department/send-test-email',
                data: data,
                success: function(response) {
                    $('.bb-preloader-container').hide();
                    $('#testing_email_modal').modal('hide');
                    $('.error-log').addClass('d-none');
                },
                error: function(resp) {
                    $('.error-log').text(resp.responseJSON.message);
                    $('.error-log').removeClass('d-none');
                    $('.bb-preloader-container').hide();
                }
            })
        })
    },
    checkEmail(val) {
        let regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

        if (regex.test(val)) {
            return true;
        } else {
            return false;
        }
    },

    updateSystemEmail(){
        $('body').on('click', '.update_system_email_status', function() {
            var data = {
                id: $(this).data('campaign_id'),
                status: $(this).data('status_id'),
            }
            $('.bb-preloader-container').show();
            $.ajax({
                type: 'POST',
                url: '/email-department/system/update-status',
                data: data,
                success: function (response) {
                    $('.bb-preloader-container').hide();
                    location.reload(true);
                }
            });
        });
    },

    checkingBusinessEmail(){
        $('body').on('click','.setup_business_email_btn', function (e) {
            window.location.href = '/admin/cockpit-settings/select-own-email';
        });
    },

    showEmailInFrame(){
        $('#email_frame').on('load', function() {
            setTimeout(
                function() {
                    let elem = $("#email_frame").contents().find("body").children()[0];
                    let h = $(elem).height();
                    $("#email_frame").height(h);
                }, 200
            );
        })
    },

    initPagination(){
        if (window.location.pathname == '/email-department') {
            this.sectionSwitcher = new SectionSwitcher();
            this.sectionListener();
            if (window.location.search.includes('system-email')) {
                setTimeout(() => {
                    $('.section.system-emails').click();
                }, 300);
            }
        }
    },

    sectionListener(){
        $('.section').click(function(e) {
            if ($(this).hasClass('email-campaigns')) {
                $('.filter_email_campaigns').removeClass('d-none');
                $('.filter_email_campaigns').addClass('d-flex');
            } else {
                $('.filter_email_campaigns').removeClass('d-flex');
                $('.filter_email_campaigns').addClass('d-none');
            }
        });
    },

    // createAutoTicket(){
    //     const auto_ticket = new AutoTicket('#sender-not-verified-modal', '.create-ticket-button');
    //     $('.create-ticket-button').click(() => {
    //         $('#sender-not-verified-modal').modal('hide');
    //         // const help_ticket = new HelpTicket();
    //         // help_ticket.openModal('create');
    //         // help_ticket.autocompleteForm("Something wrong while creating email campaign", $(this).data('description'));
    //         this->noname();
    //     });
    // }

    initDescriptionModals(){
        $('body').on('mouseover', '.email-campaign-description-logo', function(){
            const type = $(this).data('type');
            const days = String($(this).data('days'));
            console.log(days,days.length);
            if (days && days.length>0) {
                $(`.email-campaign-description.${type}`).find('.days').text(days);
            }
            $(`.email-campaign-description.${type}`).show();
            let posX = $(this).offset().left;
            if (document.documentElement.clientWidth < ($(this).offset().left + $(`.email-campaign-description.${type}`).width())) {
                //console.log($(this).offset().left,  $(`.email-campaign-description.${type}`).width());
                posX = $(this).offset().left - $(`.email-campaign-description.${type}`).width() - 50;
            }
            let posY = $(this).offset().top + 15;
            $(`.email-campaign-description.${type}`).css({left: posX, top: posY});
        })
        $('body').on('mouseout', '.email-campaign-description-logo', function(){
            const type = $(this).data('type');
            $(`.email-campaign-description.${type}`).hide();
        })
    },

    uploadCallback(response){
        $('#body_img').attr('src', response);
        $("#email_frame").contents().find('#body_img').attr('src', response);
        $('#path_img').val(response);
        let filename = response.split('/');
        filename = filename[filename.length-1];
        $('.file_name').text(filename);
    }
}
